module.exports = __webpack_public_path__ + "img/Hand-mit-Schatten_Mockup.90b10c3a.png";